export default async function preCheck() {
    // check and prepare environment
    // 1. fix old urls
    if (document.location.hash.indexOf('!/') != -1) {
        document.location.hash = document.location.hash
            .replace('!/', '')
            .replace('#/consolidation-tool/', '#/planning-tool/');
    }
}
